import React, { useState } from 'react';
import { Home, Search, Heart, Bell, User } from 'lucide-react';
import "./style.css"

const AnimatedNavigation = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const navItems = [
    { id: 'home', name: 'Home', icon: Home },
    { id: 'search', name: 'Search', icon: Search },
    { id: 'favorites', name: 'Favorites', icon: Heart },
    { id: 'notifications', name: 'Notifications', icon: Bell },
    { id: 'profile', name: 'Profile', icon: User }
  ];

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="animated-nav-demo">
      <nav 
        className="morphic-nav" 
        style={{ '--active-index': activeIndex, '--items-count': navItems.length }}
      >
        {navItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <button
              key={item.id}
              className={`nav-item ${index === activeIndex ? 'active' : ''}`}
              style={{ '--item-index': index }}
              onClick={() => handleItemClick(index)}
              aria-label={item.name}
            >
              <IconComponent 
                size={36} 
                className="nav-icon"
              />
              <span className="nav-label">{item.name}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default AnimatedNavigation;